import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/step_check.png'
import _imports_1 from '@/assets/images/approval_icon.png'


const _hoisted_1 = { class: "page" }

import { onMounted } from "vue";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'CertificateApprovalView',
  setup(__props) {

const router = useRouter();

const goPage = (page: string) => {
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};
onMounted(() => {
  console.log('dfdfdfd')
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"page_header\" data-v-bd1dc918>회원가입</div><div class=\"page_header_line\" data-v-bd1dc918></div><div class=\"steps\" data-v-bd1dc918><div class=\"step active\" data-v-bd1dc918><div class=\"step_circle\" data-v-bd1dc918><img src=\"" + _imports_0 + "\" data-v-bd1dc918><div class=\"step_label\" data-v-bd1dc918>약관동의</div></div></div><div class=\"step active\" data-v-bd1dc918><div class=\"step_line\" data-v-bd1dc918></div><div class=\"step_circle\" data-v-bd1dc918><img src=\"" + _imports_0 + "\" data-v-bd1dc918><div class=\"step_label\" data-v-bd1dc918>정보입력</div></div></div><div class=\"step active\" data-v-bd1dc918><div class=\"step_line\" data-v-bd1dc918></div><div class=\"step_circle\" data-v-bd1dc918><img src=\"" + _imports_0 + "\" data-v-bd1dc918><div class=\"step_label\" data-v-bd1dc918>인증서등록</div></div></div><div class=\"step active\" data-v-bd1dc918><div class=\"step_line\" data-v-bd1dc918></div><div class=\"step_circle\" data-v-bd1dc918><div class=\"step_label\" data-v-bd1dc918>심사 후 승인</div></div></div></div><div data-v-bd1dc918><img src=\"" + _imports_1 + "\" class=\"image_div\" data-v-bd1dc918></div><div class=\"approval-page__title\" data-v-bd1dc918>회원가입 <span data-v-bd1dc918>심사중</span></div><p class=\"approval-page__description\" data-v-bd1dc918> 회원 가입 신청이 완료되었습니다.<br data-v-bd1dc918> 처리 결과는 심사 일자로부터 1~3일 이내에 확인 가능하며<br data-v-bd1dc918> 처리가 완료되면 문자 메시지로 안내 드립니다. </p>", 6)),
    _createElementVNode("button", {
      class: "approval-page__button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goPage('home')))
    }, "홈으로")
  ]))
}
}

})